import { routes } from '@/configs/router/routes';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

export const routerProvider = (
  <RouterProvider router={createBrowserRouter(routes)}></RouterProvider>
);
